<template>
  <el-dialog
    title="Formulario de arrepentimiento"
    :visible.sync="verForm"
    width="360px"
    :top="'3vh'"
    :center="true"
    custom-class="modal-inner"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :destroy-on-close="true"
  >
    <div v-if="sinEnviar">
      <h3>
        Formulario de arrepentimiento
        <br />
        <small>
          Completa este formulario para gestionar tu solicitud de
          arrepentimiento de compra.
        </small>
      </h3>

      <el-form
        :model="form"
        ref="form"
        :label-position="'top'"
        :inline="false"
        size="normal"
      >
        <el-form-item
          label="Motivo"
          prop="motivo"
          :rules="[
            { required: true, message: 'campo requerido', trigger: 'blur' },
          ]"
        >
          <el-input
            maxlength="100"
            show-word-limit
            type="textarea"
            :rows="2"
            v-model="form.motivo"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Tipo de cancelación"
          size="normal"
          prop="tipo"
          :rules="[
            { required: true, message: 'campo requerido', trigger: 'blur' },
          ]"
        >
          <el-radio
            v-model="form.tipo"
            :label="m.motivo"
            size="normal"
            border
            style="width: 100%"
            @change="getMotivo(m)"
            v-for="m in datos.motivos.filter((e) =>
              [11, 12].includes(e.id)
            )"
            :key="m.id"
          >
            {{ m.motivo }}
          </el-radio>
        </el-form-item>

        <!-- <el-form-item label="Mensaje" prop="mensaje" >
    <el-input type="textarea" :rows="3" v-model="form.mensaje"></el-input>
  </el-form-item> -->
        <el-form-item label="" size="normal">
          <!-- <span>
      <strong>IMPORTANTE</strong> al enviar el formulario de arrepentimiento, el avance de su pedido se detendrá
    </span>
    <br> --><br />
          <el-button type="default" :disabled="procesando" @click="cancelar">Cancelar</el-button>
          <el-button
            type="primary"
            :loading="procesando"
            @click="submitForm('form')"
            >Enviar solicitud</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="min-height: 350px" v-if="!sinEnviar && !conError">
      <h3>Solicitud enviada correctamente</h3>
      <p>
        Recibimos sus datos y vamos a iniciar el proceso de cancelación de la
        compra.
      </p>

      <p>
        Luego de verificar el estado de su pedido, procederemos a realizar la
        devolución del dinero.
      </p>
      <p></p>
      <p>
        En caso de ser necesario, nos comunicaremos con usted para consultas.
      </p>
      <br />
      <el-button type="primary" @click="regresar">Regresar</el-button>
    </div>
      <div style="color:#f44336" v-if="!sinEnviar && conError">
      <h3>No se pudo procesar la solicitud</h3>
      <p>
         Hubo un error al intentar enviar sus datos, por favor actualice la página e intente de nuevo.
      </p>
      <br />
      <el-button type="primary" @click="regresar">Aceptar</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus";

export default {
  props:['datos'],
  data() {
    return {
      conError:false,
      verForm: false,
      form: {},
      sinEnviar: true,
      selectMotivo: undefined,
      procesando: false,
    };
  },
  created() {
    EventBus.$on("openForm", (f) => {
      this.verForm = f;
    });
    EventBus.$on("procesarArrepentimiento", (res) => {
      if (res) {
        this.sinEnviar = false;
        this.procesando = false;
      } else {
        this.procesando = false;
        this.form = {};
        this.selectMotivo = undefined;
        this.conError = true;
             this.sinEnviar = false;

        // this.$alert(
        //   "Hubo un problema al procesar la solicitud, actualice la página y reintente",
        //   { type: "error" }
        // );
      }
    });
  },
  methods: {
    ...mapActions({
      vuexCancelarPedido: "cancelarPedido",
    }),
    getMotivo(m) {
      this.selectMotivo = m;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.procesando = true;
          this.selectMotivo.causa = this.form.motivo;

          // EventBus.$emit("enviarFormCancelar", this.selectMotivo);
          // console.log("enviarFormCancelar", this.selectMotivo);
             
      let datosWc = {
        content: `Hola, me comunico para solicitar la ${this.selectMotivo.motivo.toLowerCase()}. <br> Motivo: ${this.form.motivo}`,
        dni: this.datos.dni,
        email: this.datos.mail_d
          ? this.datos.mail_d
          : "",
        fechaVtex: this.$date(this.datos.vtex_fecha.date).format(
          "DD/MM/YYYY HH:mm"
        ),
        motivoId: this.selectMotivo.id,
        nombre: this.datos.nombre + " " + this.datos.apellido,
        status: "open",
        tags: ["Arrepentimiento / Cancelado"],
       telefono: this.datos.telefono,
        totalOperacion: this.datos.importe / 100,
        vtex_id: this.datos.vtex_id,
        wcTipo: this.selectMotivo.wc_tipo,
        envio: this.datos.envio,
        priority: "high",
        motivo_id: this.selectMotivo.id
      };

      console.log('form arrependio', datosWc );
      // console.log('form motivoIngresado', m );
      // this.vuexCrearCasoWebCentrix({ datosWc, motivoIngresado: m });
//       let result = this.vuexCancelarPedido({ datosWc, motivoIngresado: this.selectMotivo });
//       result.then(res => {
// // console.log('vuexCancelarPedido', res);

// EventBus.$emit('procesarArrepentimiento', res)


//       }).catch(err => { console.log('vuexCancelarPedidoErr', err)})
      
   
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelar() {
      EventBus.$emit("openForm", false);
      this.verForm = false;
      // // this.procesando = false
      // this.sinEnviar = true
      // this.form = {}
      // this.verForm = false
      // setTimeout(() => {
      //    this.verForm = false

      // }, 100);
    },
    regresar() {
      //  this.procesando = false
       EventBus.$emit("openForm", false);
      this.form = {};
      this.verForm = false;
      this.sinEnviar = true;
    
    },
  },
};
</script>

<style lang="scss" scoped>
</style>